<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { ISection } from "../../entities/section";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { initDetail, record, save, stats } from "./section.store";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.name != "";

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<ISection> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/section/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/section`);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  {#if $record}
    <div class="columns">
      <div class="column is-12">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            <div class="column is-12">
              <FormField>
                <Input name="Name" placeholder="name" required={true} bind:value={$record.name} />
              </FormField>
            </div>
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}
</MainLayout>
